export default "__VITE_ASSET__CI$KIUow__"